/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { GridItemProps } from "@insite/mobius/GridItem";
import { contentText, titleText } from "@monsma/App/WidgetExtensions/OrderDetails/OrderDateExtension";
import { orderInformationStyles } from "@monsma/Overrides/Widgets/OrderConfirmation/OrderConfirmationOrderInformation";
import { css } from "styled-components";

const commonInfoGridItem: GridItemProps = {
    width: [12, 6, 4, 4, 4],
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

orderInformationStyles.OrderInformationGridContainer = {
    gap: 30,
};

orderInformationStyles.shippingInformationGridItem = {
    width: [12, 6, 6, 6, 6],
};

orderInformationStyles.billingInformationGridItem = {
    width: [12, 6, 6, 6, 6],
};

orderInformationStyles.notesGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `
};

orderInformationStyles.notesTitle = titleText;

orderInformationStyles.notesDescription = contentText;

orderInformationStyles.orderNumberGridItem = commonInfoGridItem;

orderInformationStyles.orderNumberHeading = titleText;

orderInformationStyles.orderNumberText = contentText;

orderInformationStyles.vatNumberGridItem = commonInfoGridItem;

orderInformationStyles.vatNumberTitleText = titleText;

orderInformationStyles.vatNumberText = contentText;

orderInformationStyles!.xOrderConfirmationInfo = {
    mainInformationGridItem: {
        width: 12,
    },
    mainInformationGridContainer: {
        gap: 15,
    },
    addressesGridItem: {
        width: 12,
    },
    addressesContainer: {
        gap: 30,
    },
    shippingInformationPoNumberGridItem: commonInfoGridItem,
    shippingPoNumberTitle: titleText,
    shippingPoNumberText: contentText,
    shippingInformationCarrierGridItem: commonInfoGridItem,
    shippingCarrierTitle: titleText,
    shippingCarrierText: contentText,
    shippingInformationDateRequestedGridItem: commonInfoGridItem,
    shippingDateRequestedTitle: titleText,
    shippingDateRequestedText: contentText,
    shippingInformationServiceGridItem: commonInfoGridItem,
    shippingServiceTitle: titleText,
    shippingServiceText: contentText,
    shippingInformationOrderDateGridItem: commonInfoGridItem,
    shippingOrderDateTitle: titleText,
    shippingOrderDateText: contentText,
    shippingInformationStatusGridItem: commonInfoGridItem,
    shippingStatusTitle: titleText,
    shippingStatusText: contentText,
    shippingInformationSalespersonGridItem: commonInfoGridItem,
    shippingSalespersonTitle: titleText,
    shippingSalespersonText: contentText,
    shippingInformationJobNameGridItem: commonInfoGridItem,
    shippingJobNameTitle: titleText,
    shippingJobNameText: contentText,
};
